/**
 * TrackerCapacitySection — the Rules tab's Capacity panel, for a tracker with
 * a queue. Capacity limits are enforced only by the queue rotation, so a
 * tracker without one (Tres Commas) is not offered them; limits already saved
 * on its config show as one inert line that can be cleared.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Gauge } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';
import { useDrawerProfile, useFlowTrackerName } from '@/features/flow-optimizer/tracker';

import CapacitySection, { type CapacitySectionProps } from './CapacitySection';

const TrackerCapacitySection: FC<CapacitySectionProps> = ({ rules, onChange }) => {
  const { queue } = useDrawerProfile();
  const trackerName = useFlowTrackerName();
  if (queue) return <CapacitySection rules={rules} onChange={onChange} />;
  if (rules.length === 0) return null;
  return (
    <p className="flex items-center gap-2 rounded-md border border-border/70 bg-muted/20 px-3 py-2 text-[11px] text-muted-foreground">
      <Gauge className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span className="flex-1">
        {rules.length} capacity limit{rules.length === 1 ? '' : 's'} saved — needs the queue, not
        run on {trackerName}.
      </span>
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="h-6 px-2 text-[11px]"
        onClick={() => onChange([])}
      >
        Remove
      </Button>
    </p>
  );
};

export default TrackerCapacitySection;
